import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js"

export default class extends Controller {
  static values = {
    totalAgents: Number,
    unresponsiveAgents: Number,
    outdatedAgents: Number,
    isolatedAgents: Number,
    liveAgentsUrl: String,
    unresponsiveAgentsUrl: String,
    outdatedAgentsUrl: String,
    isolatedAgentsUrl: String
  }

  connect() {
    this.initializeChart()
    this.themeObserver = new MutationObserver(() => {
      if (!this.chart) return
      this.chart.data.datasets.forEach(d => {
        d.borderColor = this.cssVar("--color-donut-chart-segment-border")
        d.hoverBorderColor = this.cssVar("--color-donut-chart-segment-border-hover")
      })
      this.chart.update()
    })
    this.themeObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] })
  }

  disconnect() {
    this.themeObserver.disconnect()
    if (this.chart) this.chart.destroy()
  }

  initializeChart() {
    const canvas = this.element.querySelector("#systems-chart")
    if (!canvas) return

    this.chart = new Chart(canvas, {
      type: "doughnut",
      data: this.donutChartData,
      options: {
        legend: {
          display: false,
        },
        onClick: function(evt, activeElements) {
          if (activeElements.length < 1) return

          const index = activeElements[0]._index
          if (index == 1)
            window.location.href = this.unresponsiveAgentsUrlValue
          else if (index == 2)
            window.location.href = this.outdatedAgentsUrlValue
          else if (index == 3)
            window.location.href = this.isolatedAgentsUrlValue
          else
            window.location.href = this.liveAgentsUrlValue
        }.bind(this)
      }
    })
  }

  cssVar(name, fallback = "#ffffff") {
    return getComputedStyle(document.body).getPropertyValue(name).trim() || fallback
  }

  get donutChartData() {
    const liveAgents = this.totalAgentsValue - this.unresponsiveAgentsValue - this.outdatedAgentsValue - this.isolatedAgentsValue

    return {
      datasets: [{
        data: [
          liveAgents,
          this.unresponsiveAgentsValue,
          this.outdatedAgentsValue,
          this.isolatedAgentsValue,
        ],
        backgroundColor: ["#18BC9C", "#f39c12", "#e74c3c", "#6f42c1"],
        borderColor: this.cssVar("--color-donut-chart-segment-border"),
        hoverBorderColor: this.cssVar("--color-donut-chart-segment-border-hover"),
      }],
      labels: ["Live Agents", "Unresponsive Agents", "Outdated Agents", "Isolated Agents"],
    }
  }
}
